import styled from "styled-components";
import { Icon } from "../../../../../components";

export const Overlay = styled.div`
    padding: 0 20px;
    width: calc(100vw - 40px);
    height: 100vh;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    background-color: ${(props) => props.theme.colors.opacityLightGrey20};
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 980px;
    margin: 0 auto;
`;

export const Container = styled.div`
    max-width: 980px;
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: ${(props) => props.theme.colors.primaryWhite};
    border-radius: 20px;

    @media (max-width: 768px) {
        max-width: 95vw;
        padding: 16px;
    }

    @media (max-width: 480px) {
        max-width: 98vw;
        padding: 12px;
    }
`;

export const Video = styled.video`
    width: 100%;
    border-radius: 20px;
`;

export const KinescopeIframe = styled.iframe`
    width: 100%;
    height: 500px;
    border-radius: 20px;
    border: none;

    @media (max-width: 768px) {
        height: 300px;
    }

    @media (max-width: 480px) {
        height: 250px;
    }
`;

export const CloseButton = styled(Icon)`
    transform: scale(1.5);
    position: absolute;
    right: -8px;
    top: 15px;
    cursor: pointer;
    fill: #000;

    @media (max-width: 768px) {
        right: 3px;
        top: -22px;
        width: 34px;
        height: 34px;
    }
`;
